const termly = `
<div name="termly-embed" data-id="e1d59dc0-739b-4bc0-bfa4-0575772049aa" data-type="iframe"></div>
`;

export default termly;
